<template>
  <div class="text-center">
    <img v-if="user.avatar" :src="imageUrl(user.avatar)" width="100%" />
    <img v-if="!user.avatar" src="/media/svg/avatars/001-boy.svg" />
    <button class="btn btn-success btn-sm mt-4" id="pick-avatar">
      Select an image
    </button>
    <avatar-cropper
      @uploaded="handleUploaded"
      trigger="#pick-avatar"
      :upload-url="urlUpload()"
      :labels="labels"
    />
  </div>
</template>

<script>
import AvatarCropper from "vue-avatar-cropper";
import axios from "axios";
import Swal from "sweetalert2";

export default {
  props: {
    user: Object,
    type: String
  },
  components: { AvatarCropper },
  data() {
    return {
      userAvatar: undefined,
      labels: { submit: "OK", cancel: "Cancel" }
    };
  },
  methods: {
    imageUrl(a) {
      return process.env.VUE_APP_API_URL + a;
    },
    urlUpload() {
      return process.env.VUE_APP_API_URL + "upload";
    },
    handleUploaded(response) {
      this.user.avatar = response.file.path;
      axios.put("users/" + this.user._id, this.user).then(response => {
        if (response.status == 200) {
          Swal.fire({
            title: "Update profile",
            text: "",
            icon: "success"
          });
        }
      });
    }
  }
};
</script>
